export default function BuildingAutocomplete({ value, onChange, required = false }) {
  return (
    <div className="building-autocomplete">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Start typing your building, society, tower, or landmark"
        className="autocomplete-input"
        required={required}
        autoComplete="off"
      />
    </div>
  );
}
